<template>
  <div>
    <div class="flex justify-between items-center">
      <PageHeader title="Grille de primes" />
      <SecondaryButton @click="() => downloadRetributionConfigurationsPdf(selectedStoreId)">Exporter</SecondaryButton>
    </div>

    <Loading v-if="isLoadingRetributionConfigurations" />
    <RetributionTable
      v-else
      :retributions="retributionConfigurations"
      :hideManagerRetribution="isSeller"
      hide-store-remuneration
    />
  </div>
</template>

<script>
import { PageHeader, Loading, SecondaryButton } from "@estaly/ui";
import RetributionTable from "@/components/retribution/RetributionTable.vue";
import StoreService from "@/api/services/store.js";
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    PageHeader,
    SecondaryButton,
    RetributionTable,
    Loading,
  },

  mounted() {
    this.fetchRetributionConfigurations();
  },

  data() {
    return {
      isLoadingRetributionConfigurations: true,
      retributionConfigurationsModalOpen: false,
      retributionConfigurations: [],
    };
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapGetters("auth", ["isSeller"]),
  },

  methods: {
    ...mapActions("retributionConfigurations", ["downloadRetributionConfigurationsPdf"]),
    async fetchRetributionConfigurations() {
      const response = await StoreService.getRetributionConfigurations(this.selectedStoreId);
      if (!response.success) return;

      this.retributionConfigurations = response.data;
      this.isLoadingRetributionConfigurations = false;
    },
  },
};
</script>
